import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { compose, lifecycle } from 'recompose';
import { signOut } from '@modules/login/_loginActions';

import { withNotifications } from '@components/hoc/withNotifications';

const enhance = compose<any, any>(
  withRouter,
  withNotifications({ signOut }),
  lifecycle<any, any, any>({
    componentDidMount() {
      const { history, signOutNotify } = this.props;

      signOutNotify(history);
    }
  })
);

export const LogoutPage = enhance(() => <></>);



// WEBPACK FOOTER //
// ./src/modules/logout/LogoutPage.tsx